import { mapValues } from "@bounce/util"

import { OverrideMode, useVariantOverrides } from "../hooks/useVariantOverrides"
import type { Variant } from "../types"

type SetVariantOverridesArgs = {
  variants: Record<string, string | Variant>
  mode?: OverrideMode
}

export const setVariantOverrides = ({ variants, mode = OverrideMode.OverridesOnly }: SetVariantOverridesArgs) => {
  const overrides = mapValues(variants, variant => (typeof variant === "string" ? { value: variant } : variant))

  useVariantOverrides.setState({
    mode,
    overrides,
  })
}
